/*
 * Copyright (c) Nexign, JSC, 2019-2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.13.0
 * @since 1.0.0
 */

import get from 'lodash/get';
import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../../reducers/rootReducer';
import { AccessComponentKeyEnum } from '../constants/guard/guardConstants';
import { guardComponentType, IGuardReducer } from '../reducer/guardReducer';

const selectGuard = (state: IRootReducer): IGuardReducer => state.guard;

export const makeSelectGuardComponents = (): OutputSelector<IRootReducer, guardComponentType,
    (state: IGuardReducer) => guardComponentType> =>
    createSelector(
        selectGuard,
        (state: IGuardReducer) => state.components,
    );

export const makeSelectGuardIsLoaded = (): OutputSelector<IRootReducer, boolean, (state: IGuardReducer) => boolean> =>
    createSelector(selectGuard, (state: IGuardReducer) => state.isLoaded);

/**
 * @deprecated
 * @see makeSelectGuardComponentEnabled
 */
export const makeSelectIsColumnResizeEnabled = (): OutputSelector<IRootReducer, boolean,
    (state: IGuardReducer) => boolean> =>
    createSelector(
        selectGuard,
        (state: IGuardReducer) => {
            return get(state, `components.${AccessComponentKeyEnum.columnResize}`, false);
        },
    );

/**
 * @deprecated
 * @see makeSelectGuardComponentEnabled
 */
export const makeSelectIsDensityListViewEnabled = (): OutputSelector<IRootReducer, boolean,
    (state: IGuardReducer) => boolean> =>
    createSelector(
        selectGuard,
        (state: IGuardReducer) => {
            return get(state, `components.${AccessComponentKeyEnum.DensityListView}`, false);
        },
    );

/**
 * @deprecated
 * @see makeSelectGuardComponentEnabled
 */
export const makeSelectLabelsImportButtonEnabled = (): OutputSelector<IRootReducer, boolean,
    (state: IGuardReducer) => boolean> =>
    createSelector(
        selectGuard,
        (state: IGuardReducer) => {
            return get(state, `components.${AccessComponentKeyEnum.LabelsImportButton}`, false);
        },
    );

/**
 * @deprecated
 * @see makeSelectGuardComponentEnabled
 */
export const makeSelectWizardCallsDetailEnabled = (): OutputSelector<IRootReducer, boolean,
    (state: IGuardReducer) => boolean> =>
    createSelector(
        selectGuard,
        (state: IGuardReducer) => {
            return get(state, `components.${AccessComponentKeyEnum.PageWizardCallsDetail}`, false);
        },
    );

/**
 * @deprecated
 * @see makeSelectGuardComponentEnabled
 */
export const makeSelectPageProductsEnabled = (): OutputSelector<IRootReducer, boolean,
    (state: IGuardReducer) => boolean> =>
    createSelector(
        selectGuard,
        (state: IGuardReducer) => {
            return get(state, `components.${AccessComponentKeyEnum.PageProducts}`, false);
        },
    );

export const makeSelectGuardComponentEnabled = (key: AccessComponentKeyEnum):
    OutputSelector<IRootReducer, boolean, (state: IGuardReducer) => boolean> =>
    createSelector(
        selectGuard,
        (state: IGuardReducer) => {
            return get(state, `components.${key}`, false);
        },
    );
